module.exports = __webpack_public_path__ + "static/media/s.2624eac7.png";